<template>
    <div
        v-if="!isSplashPage"
        ref="steps"
        class="cz2__steps"
    >
        <div
            class="cz2__sb-border_3-wrapper"
            v-if="!isNameStep && !isCheckoutStep && !isReviewStep && !isContactStep"
        >
            <div class="cz2__sb-border_3" />
        </div>

        <!-- <img
            v-if="(!isNameStep && !isReviewStep) || (isReviewStep && isKiosk)"
            src="../assets/images/toty-logo.png"
            :alt="$t('LOGO_TOTY')"
            class="cz2__toty-logo"
        > -->

        <div
            v-if="!isMobileApp && showFunkoLogo"
            :class="{ 'cz2__funko-logo--is-checkout': isCheckoutStep }"
            class="cz2__funko-logo-wrapper"
        >
            <funko-logos />
        </div>

        <funko-logo
            v-if="!isReviewStep"
            class="cz2__splash__logo--mariners"
        />

        <!-- <a
            v-if="!isNameStep && !isCheckoutStep && !isReviewStep"
            :href="funkoUrl"
            class="cz2__sb-funko-logo"
            :aria-label="$t('FUNKO_HOME')"
            @click="tapLogo"
        >
            <img
                src="../assets/images/branded/sb-final/SB-Logo_Funko.webp"
            />
        </a> -->

        <a
            v-if="isEmea && !isNameStep && !isCheckoutStep && !isReviewStep"
            class="cz2__emea-logo"
            :href="funkoUrl"
            @click="tapLogo"
        >
            <img
                src="../assets/images/branded/dadsnet-awards/dadsnet-logo@2x.png"
                alt="Dadsnet Awards Logo"
            >
        </a>

        <renderer
            :style="{
                'mask-image': rendererMaskImage ? `url(&quot;${rendererMaskImage}&quot;)` : null,
            }"
        />

        <steps-options />

        <brand-copyright />
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__sb-funko-logo {
            display: none;
        }
        .cz2__steps {
            position: absolute;

            left: 0%;
            right: 0%;
            top: 0%;
            bottom: 0%;

            // Start below the fold.
            transform: translateY(100%);

            @include bg(gradientBlue);
            background-size: 100% var(--steps-options-height);
            background-position-y: bottom;
            background-repeat: no-repeat;

            .cz2__toty-logo {
                top: 4px;
                left: 4px;
            }

            @include respond-above(xl) {
                background-size: 50% 100%;
                background-position-x: right;
            }

            @include respond-above(xl) {
                .cz2__funko-logo {
                    width: 209px;
                    height: 71px;

                }
            }
            .cz2__funko-logo-wrapper {
                margin-top: 16px;

                display: flex;
                justify-content: center;

                position: relative;
                z-index: 1;
                background: transparent;
            }

            .cz2__funko-logo {
                width: 70px;
                height: 24px;
            }

            @include respond-above(xl) {
                background-size: 50% 100%;
                background-position-x: right;

                .cz2__funko-logo-wrapper {
                    margin-right: 50%;
                }

                .cz2__funko-logo {
                    width: 94px;
                    height: 32px;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__steps {
            background-size: 100% 50%;
            background-color: color(v2BlueMedium);

            .cz2__toty-logo {
                top: 8px;
                left: 8px;
            }

            .cz2__funko-logo--is-checkout {
                display: none;
                // background-color: transparent;
                // position: absolute;
            }

            .cz2__funko-logo-wrapper {
                position: absolute;

                margin-top: 33.35px;

                width: 100%;
                left: 0;
            }

            .cz2__funko-logo {
                width: 188px;
                height: 64.2px;
            }
        }
    }

    #cz2.cz2__is-sb {
        .cz2__steps {
            background-color: transparent;
        }

        .cz2__sb-border_3-wrapper {
            position: absolute;
            background-image: url('../assets/images/branded/sb-final/SB-BuildMaxGradient_K@3x.svg');
            background-size: 100% 100%;
            height: 48%;
            width: 100%;
            background-position: 0 0;
            background-origin: border-box;

            @include respond-above(md) {
                height: 50%;
            }

            @include respond-above(lg) {
                height: calc(100%);
                width: calc(50%);
                background-image: url('../assets/images/branded/sb-final/SB-BuildMaxGradient_D@3x.svg');
                background-size: 100% 100%;
            }
        }
        .cz2__sb-border_3 {
            position: absolute;
            border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_M@2x.webp');

            border-width: 40px;
            border-image-width: 40px;
            border-image-slice: 80 fill;
            border-image-repeat: stretch;

            height: 100%;
            width: 100%;

            @include respond-above(lg) {
                border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_D@2x.webp');
                height: 100%;
                width: 100%;
                border-width: 70px;
                border-image-width: 70px;
                border-image-slice: 140 fill;
                border-image-repeat: stretch;
            }
        }
        .cz2__sb-funko-logo {
            display: block;
            position: absolute;
            width: 88px;
            height: 30px;
            top: 32px;
            left: 32px;

            z-index: 100010;

            img {
                width: 100%;
                height: 100%;
            }

            cursor: pointer;

            @include respond-above(lg) {
                top: 75px;
                left: 75px;
                width: 117px;
                height: 40px;
            }
        }
    }

    #cz2.cz2.cz2__is-sb.cz2__is-kiosk {
        .cz2__steps {
            background-color: transparent;
        }

        .cz2__sb-border_3-wrapper {
            position: absolute;
            background-image: url('../assets/images/branded/sb-final/SB-BuildMaxGradient_K@3x.svg');
            background-size: cover;
            height: calc(48%);
            width: calc(100%);
            top: 0;
            left: 0;
            right: 0;
        }

        .cz2__sb-border_3 {
            border-image-source: url('../assets/images/branded/sb-final/SB-Border 2B_K@2x.webp');
            height: 100%;
            width: 100%;
            border-width: 70px;
            border-image-width: 70px;
            border-image-slice: 140 fill;
            border-image-repeat: stretch;
        }
    }

    #cz2.cz2.cz2__is-mariners {
        .cz2__steps {
            background: white;
        }
    }

    #cz2.cz2.cz2__is-mariners {
        .cz2__steps {
            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: calc(100% - var(--steps-options-height));
                background-image: url(../assets/images/branded/pokemon/pokemon-bg.jpg);
                background-size: cover;
                background-repeat: no-repeat;
                background-position: top left;

                @include respond-above(xl) {
                    height: 100%;
                    width: 50%;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-mariners.cz2__is-name-step,
    #cz2.cz2.cz2__is-mariners.cz2__is-review-step,
    #cz2.cz2.cz2__is-mariners.cz2__is-checkout-step {
        .cz2__steps {
            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                background-image: url(../assets/images/branded/pokemon/pokemon-bg.jpg);
                // background-size: contain;
                background-repeat: repeat;
                // background-position: top left;

                height: 100%;
                width: 100%;
            }
        }
    }

    #cz2.cz2.cz2__is-mariners.cz2__is-checkout-step {
        .cz2__steps {
            &::before {
                background-image: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%),
                url(../assets/images/branded/pokemon/pokemon-bg.jpg);
                background-size: contain;
                background-repeat: no-repeat;
                background-position-y: bottom;
            }

            .cz2__funko-logo--is-checkout {
                justify-content: end;
                margin-right: 32px;
                .cz2__funko-logo-link,
                .sm-x-icon {
                    display: none;
                }
            }
        }
    }

    #cz2.cz2__is-emea {
        .cz2__steps {
            .cz2__emea-logo img {
                display: block;
                position: absolute;
                top: 8px;
                left: 8px;
                width: 56px;
                height: 56px;
                z-index: 1;
                @include respond-above(lg) {
                    top: 16px;
                    left: 24px;
                    width: 90px;
                    height: 90px;
                }
            }
        }
    }
</style>

<script>
    // eslint-disable-next-line no-unused-vars
    import { animate, spring } from 'motion';

    import FunkoLogo from './FunkoLogo.vue';
    import Renderer from './Renderer.vue';
    import StepsOptions from './StepsOptions.vue';
    import BrandCopyright from './ui/BrandCopyright.vue';
    import FunkoLogos from './FunkoLogos.vue';

    export default {
        components: {
            FunkoLogo,
            Renderer,
            StepsOptions,
            BrandCopyright,
            FunkoLogos,
        },

        data() {
            return {
                rendererMaskImage: null,
            };
        },

        computed: {
            currentGroup() {
                return this.$store.state.customizer.currentGroup;
            },

            isEmea() {
                return this.$store.state.customizer.options.site === 'ecommerce,ecommerce-eu';
            },

            currentGroupCode() {
                return this.currentGroup?.code;
            },

            isSplashPage() {
                return this.$store.state.selectedStep === 'splash' || this.$store.state.selectedStep === 'splashSelector';
            },

            isNameStep() {
                return this.currentGroupCode === 'Name';
            },

            isReviewStep() {
                return this.currentGroupCode === 'Review';
            },

            isCheckoutStep() {
                return this.currentGroupCode === 'Checkout';
            },

            isContactStep() {
                return this.currentGroupCode === 'Contact';
            },

            isConfirmStep() {
                return this.currentGroupCode === 'Confirm';
            },

            showFunkoLogo() {
                // const standardLogic = !this.isNameStep && !this.isReviewStep && !this.isCheckoutStep && !this.isConfirmStep;
                // const marinersLogic = !this.isNameStep && !this.isReviewStep && !this.isCheckoutStep;

                // // Overrides.
                // if (this.isKiosk && (this.isNameStep || this.isCheckoutStep || this.isReviewStep)) {
                //     return true;
                // }

                // return this.isMariners ? marinersLogic : standardLogic;
                return false;
            },

            funkoUrl() {
                return this.globalSettings?.['fun-site-url'] ?? 'https://www.funko.com/';
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            isMobileApp() {
                return this.$store.state.customizer.isMobileApp;
            },

            globalSettings() {
                return this.$store.state.customizer?.globalSettings?.blueprint?.custom;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            spellingBeeType() {
                return this.$store.state.spellingBeeType ?? 'none';
            },

            isMariners() {
                return this.$store.state.isMariners;
            },
        },

        watch: {
            isSplashPage(newValue) {
                if (newValue === false) {
                    this.alreadyAnimated = true;
                    this.animateIn();
                }
            },

            currentGroup() {
                this.resize();
            },
        },

        mounted() {
            this.resize();

            window.addEventListener('resize', this.resize);
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.resize);
        },

        methods: {
            async animateIn() {
                // Render refs first.
                await this.$nextTick();

                this.resize();

                // Animate the splash away.
                animate(this.$refs.steps, {
                    transform: [
                        'translateY(100%)',
                        'translateY(0)',
                    ],
                }, {
                    duration: 1,
                    easing: spring(),
                });
            },

            flipPops() {
                // this.$store.getters.popControllers will give a list of all pops.
                // this.$store.state.customizer.viewController is the current pop.
                // Thus to flip a pop we need to select another.

                const current = this.$store.state.customizer.viewController;
                const notCurrent = this.$store.getters.popControllers.find((x) => x !== current);

                this.$store.dispatch('selectPop', notCurrent);
            },

            tapLogo($event) {
                if (this.isKiosk) {
                    $event.preventDefault();

                    this.$store.dispatch('tapLogo');
                } else {
                    $event.preventDefault();

                    // Show exit warning modal
                    this.$store.dispatch('showExitModal', true);
                }
            },

            resize() {
                if (this.$refs.steps && this.isSpellingBee) {
                    let mask = true;

                    if (this.isNameStep) {
                        mask = false;
                    }

                    if (this.isReviewStep) {
                        mask = false;
                    }

                    if (this.isCheckoutStep) {
                        mask = false;
                    }

                    if (this.isContactStep) {
                        mask = false;
                    }

                    if (this.isConfirmStep) {
                        mask = false;
                    }

                    if (mask) {
                        const canvas = document.createElement('canvas');

                        let w = this.$refs.steps.offsetWidth;
                        // eslint-disable-next-line prefer-const
                        let h = this.$refs.steps.offsetHeight;

                        const totalH = h;

                        if (window.innerWidth >= 1024 && !this.isKiosk) {
                            // eslint-disable-next-line operator-assignment
                            w = w * 0.5;

                            let padding = 44 + 16;

                            if (window.innerWidth >= 1280) {
                                padding = 71 + 16 + 16;
                            }

                            h -= padding;
                        } else {
                            // eslint-disable-next-line operator-assignment
                            h = h * 0.48;
                        }

                        canvas.width = w;
                        canvas.height = totalH;

                        const ctx = canvas.getContext('2d');

                        ctx.clearRect(0, 0, w, totalH);

                        ctx.fillStyle = 'white';
                        ctx.fillRect(48, 0, w - 96, h - 48);

                        this.rendererMaskImage = canvas.toDataURL();

                        return;
                    }
                }

                this.rendererMaskImage = null;
            },
        },
    };
</script>
